export default __webpack_public_path__ + "f3fcaeae5e48b8c093cb6e6377e4843f.svg";